// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__nD4p9","active":"Category_active__UdX9h","label":"Category_label__gt-Jr","disabled":"Category_disabled__MdfBe"};